import styled from '@emotion/styled';
import { color, typography } from '@uniquegood/realworld-studio-design';
import { BillingPeriod } from '../../types';

interface PricingToggleProps {
  selected: BillingPeriod;
  onChange: (period: BillingPeriod) => void;
}

const PricingToggle = ({ selected, onChange }: PricingToggleProps) => {
  return (
    <ToggleContainer>
      <ToggleButton
        isActive={selected === 'monthly'}
        onClick={() => onChange('monthly')}
        type="button"
      >
        월간
      </ToggleButton>
      <ToggleButton
        isActive={selected === 'yearly'}
        onClick={() => onChange('yearly')}
        type="button"
      >
        연간
      </ToggleButton>
    </ToggleContainer>
  );
};

export default PricingToggle;

const ToggleContainer = styled.div`
  display: inline-flex;
  background: ${color.white};
  border-radius: 8px;
  padding: 2px;
  gap: 0;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.07);
`;

const ToggleButton = styled.button<{ isActive: boolean }>`
  padding: 6px 0;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  line-height: 24px;
  font-weight: ${typography.weight.bold};
  cursor: pointer;
  transition: all 0.2s;
  width: 96px;
  height: 36px;

  background: ${({ isActive }) => (isActive ? '#f4f0ff' : 'transparent')};
  color: ${({ isActive }) => (isActive ? '#7800ff' : '#adadad')};

  &:hover {
    color: ${({ isActive }) => (isActive ? '#6600e6' : '#8f8f8f')};
  }
`;
